import { useSelector } from "react-redux";
import {
  getConnectionRoomId,
  getUserRole,
} from "datamodel/Conversation/selectors";
import { damageCoverageSelector } from "datamodel/Features/selectors";
import { isLister } from "datamodel/User/utils";
import { usePremium, PREMIUM_CAPABILITIES } from "modules/premium";

export const useDamageCoverage = ({ roomId = 0, userRole = null } = {}) => {
  const dmgCoverageEnabled = useSelector(damageCoverageSelector);
  const role = userRole || useSelector(getUserRole);
  const { hasCapability } =
    dmgCoverageEnabled && isLister(role)
      ? usePremium({
          roomId: roomId || useSelector(getConnectionRoomId),
          capabilityId: PREMIUM_CAPABILITIES.DAMAGE_COVERAGE,
        })
      : { hasCapability: false };

  return hasCapability;
};
